import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { PlayCircleIcon } from 'lucide-react';
export const Hero = () => {
  return <section className="py-16 md:py-24 bg-gradient-to-b from-white to-brand-light" data-id="element-107">
      <div className="container-custom" data-id="element-108">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-109">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-center lg:text-left" data-id="element-110">
            <h1 className="text-4xl md:text-5xl font-bold text-brand-blue mb-6 leading-tight" data-id="element-111">
              Run your daily work from one shared workspace.
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-lg mx-auto lg:mx-0" data-id="element-112">
              Daily Serve brings tasks, messages, and client updates into one
              organised platform so teams stay aligned every day.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-113">
              <Link to="/trial" className="btn-primary text-center px-8 py-3 text-base" data-id="element-114">
                Start free trial
              </Link>
              <Link to="/demo" className="btn-secondary text-center px-8 py-3 text-base flex items-center justify-center" data-id="element-115">
                <PlayCircleIcon size={20} className="mr-2" data-id="element-116" />
                Book a demo
              </Link>
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="rounded-xl shadow-xl overflow-hidden" data-id="element-117">
            <div className="bg-brand-blue text-white p-2 flex items-center space-x-2" data-id="element-118">
              <div className="flex space-x-1" data-id="element-119">
                <div className="w-3 h-3 rounded-full bg-red-500" data-id="element-120"></div>
                <div className="w-3 h-3 rounded-full bg-yellow-500" data-id="element-121"></div>
                <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-122"></div>
              </div>
              <div className="text-xs" data-id="element-123">Daily Serve - Workspace</div>
            </div>
            <div className="bg-white p-4" data-id="element-124">
              <div className="grid grid-cols-3 gap-4 h-[400px]" data-id="element-125">
                <div className="col-span-2 bg-gray-100 rounded-lg p-3" data-id="element-126">
                  <div className="bg-brand-teal text-white text-sm p-2 rounded-t-lg" data-id="element-127">
                    Project Tasks
                  </div>
                  <div className="bg-white p-2 shadow-sm rounded-b-lg" data-id="element-128">
                    <div className="border-b pb-2 mb-2" data-id="element-129">
                      <div className="flex justify-between items-center" data-id="element-130">
                        <div className="flex items-center" data-id="element-131">
                          <div className="w-4 h-4 rounded-full bg-green-500 mr-2" data-id="element-132"></div>
                          <span className="text-sm" data-id="element-133">Client presentation</span>
                        </div>
                        <span className="text-xs bg-brand-light px-2 py-1 rounded" data-id="element-134">
                          Today
                        </span>
                      </div>
                    </div>
                    <div className="border-b pb-2 mb-2" data-id="element-135">
                      <div className="flex justify-between items-center" data-id="element-136">
                        <div className="flex items-center" data-id="element-137">
                          <div className="w-4 h-4 rounded-full bg-yellow-500 mr-2" data-id="element-138"></div>
                          <span className="text-sm" data-id="element-139">Review feedback</span>
                        </div>
                        <span className="text-xs bg-brand-light px-2 py-1 rounded" data-id="element-140">
                          Tomorrow
                        </span>
                      </div>
                    </div>
                    <div className="border-b pb-2 mb-2" data-id="element-141">
                      <div className="flex justify-between items-center" data-id="element-142">
                        <div className="flex items-center" data-id="element-143">
                          <div className="w-4 h-4 rounded-full bg-blue-500 mr-2" data-id="element-144"></div>
                          <span className="text-sm" data-id="element-145">Team meeting</span>
                        </div>
                        <span className="text-xs bg-brand-light px-2 py-1 rounded" data-id="element-146">
                          Friday
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-span-1 space-y-4" data-id="element-147">
                  <div className="bg-gray-100 rounded-lg p-3 h-1/2" data-id="element-148">
                    <div className="bg-brand-blue text-white text-sm p-2 rounded-t-lg" data-id="element-149">
                      Messages
                    </div>
                    <div className="bg-white p-2 shadow-sm rounded-b-lg h-[130px] overflow-y-auto" data-id="element-150">
                      <div className="flex mb-2" data-id="element-151">
                        <div className="w-6 h-6 rounded-full bg-gray-300 mr-2 flex-shrink-0" data-id="element-152"></div>
                        <div data-id="element-153">
                          <p className="text-xs font-medium" data-id="element-154">Sarah</p>
                          <p className="text-xs" data-id="element-155">
                            Are we ready for the client call?
                          </p>
                        </div>
                      </div>
                      <div className="flex mb-2" data-id="element-156">
                        <div className="w-6 h-6 rounded-full bg-gray-300 mr-2 flex-shrink-0" data-id="element-157"></div>
                        <div data-id="element-158">
                          <p className="text-xs font-medium" data-id="element-159">James</p>
                          <p className="text-xs" data-id="element-160">
                            Just uploaded the final files
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-100 rounded-lg p-3 h-1/2" data-id="element-161">
                    <div className="bg-brand-blue text-white text-sm p-2 rounded-t-lg" data-id="element-162">
                      Calendar
                    </div>
                    <div className="bg-white p-2 shadow-sm rounded-b-lg" data-id="element-163">
                      <div className="text-center text-xs font-medium mb-1" data-id="element-164">
                        September
                      </div>
                      <div className="grid grid-cols-7 gap-1" data-id="element-165">
                        {['M', 'T', 'W', 'T', 'F', 'S', 'S'].map((day, i) => <div key={i} className="text-center text-xs text-gray-500" data-id="element-166">
                            {day}
                          </div>)}
                        {Array.from({
                        length: 7
                      }).map((_, i) => <div key={i} className="text-center text-xs text-gray-400" data-id="element-167">
                            {i + 1}
                          </div>)}
                        {Array.from({
                        length: 7
                      }).map((_, i) => <div key={i + 7} className={`text-center text-xs ${i + 8 === 10 ? 'bg-brand-teal text-white rounded-full' : ''}`} data-id="element-168">
                            {i + 8}
                          </div>)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};